import { toast } from "react-toastify";

const checkToken = () => {
  return localStorage.getItem("token") ? true : false;
};
const getCurrentBrands = () => {
  return JSON.parse(localStorage.getItem("currentBrands"));
};
const getCurrentSelectedCustomer = () => {
  return JSON.parse(localStorage.getItem("dataSelectedCustomer"));
};
const replaceAccent = function (string) {
  var accent = [
    /[\300-\306]/g, /[\340-\346]/g, // A, a
    /[\310-\313]/g, /[\350-\353]/g, // E, e
    /[\314-\317]/g, /[\354-\357]/g, // I, i
    /[\322-\330]/g, /[\362-\370]/g, // O, o
    /[\331-\334]/g, /[\371-\374]/g, // U, u
    /[\321]/g, /[\361]/g, // N, n
    /[\307]/g, /[\347]/g, // C, c
  ];
  var noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

  var str = string;
  for (var i = 0; i < accent.length; i++) {
    str = str.replace(accent[i], noaccent[i]);
  }

  return str;
}

const notifySuccess = (action, time = 5000) =>
  toast.success(`${action} avec succès.`, {
    position: "top-right",
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

const notifyInProgress = (action, time = 5000) =>
  toast.warn(`${action}`, {
    position: "top-right",
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

const notifyError = (action, time = 5000) =>
  toast.error(`Une erreur est survenue lors ${action}.`, {
    position: "top-right",
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
  });

const getColorAlternative = (hex, alpha) => {
  return hex + alpha;
};

const Utils = {
  checkToken,
  replaceAccent,
  getCurrentBrands,
  getCurrentSelectedCustomer,
  notifySuccess,
  notifyError,
  notifyInProgress,
  getColorAlternative,
};
export default Utils;
